// extracted by mini-css-extract-plugin
export var section = "_3x-1";
export var topNav = "_3x-0";